import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as emailActions from '../../../actions/email';
import * as verifyEmailActions from '../../../actions/verifyEmail';

class Email extends React.Component {
	handleInitEmail() {
		this.props.initEmail();
	}

	handleInitVerifyEmail() {
		this.props.initVerifyEmail();
	}

	renderPCIcon() {
		if (this.props.userInfo.email_v) {
			return (
				<div className="securityhome-item__icon securityhome-item__icon--yellow securityhome-item__icon--email"></div>
			);
		} else {
			return (
				<div className="securityhome-item__icon securityhome-item__icon--gray securityhome-item__icon--email"></div>
			);
		}
	}

	renderMobileIcon() {
		if (this.props.userInfo.email_v) {
			return (
				<div className="securityhome-item__name-icon securityhome-item__name-icon--yellow securityhome-item__name-icon--email"></div>
			);
		} else {
			return (
				<div className="securityhome-item__name-icon securityhome-item__name-icon--gray securityhome-item__name-icon--email"></div>
			);
		}
	}

	renderTitle() {
		if (this.props.userInfo.email) {
			return (
				<div className="securityhome-item__name">
					{this.renderMobileIcon()}
					<span className="securityhome-item__valname">{trans('email')}: </span>
					<span className="securityhome-item__val">{this.props.userInfo.email}</span>
				</div>
			);
		} else {
			return (
				<div className="securityhome-item__name">
					{this.renderMobileIcon()}
					<span className="securityhome-item__valname">{trans('email')}</span>
					{isMobile ? <span className="securityhome-item__val">{trans('email')}</span> : null}
				</div>
			);
		}
	}

	renderAction() {
		if (this.props.userInfo.email_v) {
			return null;
		}
		if (this.props.userInfo.email) {
			return (
				<div className="securityhome-item__op">
					<a href="#" className="securityhome-item__link" onClick={this.handleInitVerifyEmail.bind(this)}>{trans('verify_action')}</a>
					<a href="#" className="securityhome-item__link" onClick={this.handleInitEmail.bind(this)}>{trans('change_action')}</a>
				</div>
			);
		} else {
			return (
				<div className="securityhome-item__op">
					<a href="#" className="securityhome-item__link" onClick={this.handleInitEmail.bind(this)}>{trans('add_action')}</a>
				</div>
			);
		}
	}

	render() {
		return (
			<div className="securityhome-item">
				{this.renderPCIcon()}
				<div className="securityhome-item__txt">
					{this.renderTitle()}
					<div className="securityhome-item__desc">
						{trans('email_description')}
					</div>
				</div>
				{this.renderAction()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, emailActions, verifyEmailActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Email);



// WEBPACK FOOTER //
// ./app/components/security/main_panel/Email.js